/* eslint-disable @typescript-eslint/no-unused-vars */
import classNames from 'classnames';
import dayjs from 'dayjs';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getEdresWalletsTransactions } from '../../api/auth';
import TransactionsImg from '../../assets/images/not-found/transactions.webp';
import { Loader } from '../../components/Loader';
import { NotFound } from '../../components/NotFound/NotFound';
import useFetch from '../../hooks/useFetch';
import useInfiniteScroll from '../../hooks/useInfiniteScroll';
import { Wallet } from '../../models/Wallet';
import { WalletTable } from '../WalletTable';
import './style.scss';

interface DetailTransactionModalProps {
  className?: string;
}

export const DetailTransactionModal = ({
  className,
}: DetailTransactionModalProps) => {
  const { t } = useTranslation(['translation']);
  const [selectedDates, setSelectedDates] = useState<Date[]>([]);
  const [totalPagesCount, setTotalPagesCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(0);
  const [transactions, setTransactions] = useState<Wallet[]>([]);

  const { isLoading, fetchData: fetchTransactions } = useFetch((page: number = 1) =>
    getEdresWalletsTransactions(page)
  );

  const loadTransactions = async () => {
    if (totalPagesCount > currentPage && !isLoading) {
      const response = await fetchTransactions(currentPage + 1);

      if (!response) return;

      setCurrentPage(currentPage + 1);
      setTransactions([...transactions, ...response.results]);
      setTotalPagesCount(Math.ceil(response.count / 12));
    }
  };

  useEffect(() => {
    if (selectedDates.length === 2) {
      const arr = JSON.parse(JSON.stringify(selectedDates));
      const dates = {
        min: dayjs(new Date(arr[0])).format('YYYY-MM-DD'),
        max: dayjs(new Date(arr[1]).setDate(new Date(arr[1]).getDate() + 1)).format(
          'YYYY-MM-DD'
        ),
      };
    }
  }, [selectedDates]);

  useEffect(() => {
    loadTransactions();
  }, []);

  const targetRef = useRef<HTMLDivElement>(null);
  useInfiniteScroll(targetRef, loadTransactions);
  const canLoadMore = totalPagesCount > currentPage;

  return (
    <>
      <div className={classNames('DetailTransactionModal', className)}>
        {!!transactions.length || isLoading ? (
          <>
            <WalletTable data={transactions} />
            {canLoadMore && (
              <>
                <div ref={targetRef} className="py-5" />
                <Loader />
              </>
            )}
          </>
        ) : (
          <NotFound
            text={t('notifications.You_dont_have_any_transactions')}
            img={TransactionsImg}
          />
        )}
      </div>
    </>
  );
};
